// privacypolicy 20feb
 /* eslint-disable */
  import React, { useState,useEffect  } from "react";
  import { auth, db, storage } from "../../firebase-config";
  import { createUserWithEmailAndPassword } from "firebase/auth";
  import { Link, useNavigate } from "react-router-dom";
  import { ref, set, onValue, push, getDatabase } from "firebase/database"; //deepa audit logs - added push and getDatabase
  import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import "./AddDoctor.css";
  import { useUserAuth } from "../../context/UserAuthContext"; //deepa css
  import { Button } from "react-bootstrap"; //deepa css

  const AddDoctor = () => {
    const [fullName, setFullName] = useState("");
    const [role, setRole] = useState("Doctor");
    const [Email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [id, setId] = useState("");
    const [signatureFile, setSignatureFile] = useState(null);
    const [signatureFileName, setSignatureFileName] = useState("");
    const { logOut } = useUserAuth(); //deepa css

    var adminName1 = localStorage.getItem("adminName");

    // Removed unused admin data fetching that was causing ID/Password field issues

    const notifyWarning = () =>
      toast.warn("Please enter valid ID/Password or Email already exists", {
        position: "top-center",
      });

    const notifySuccess = (message) =>
      toast.success(message, {
        position: "top-center",
      });

    const navigate = useNavigate();

    

    useEffect(() => {
      window.history.replaceState(null, null, window.location.href); 
      window.addEventListener("popstate", () => {
        navigate("/Admin", { replace: true }); 
      });
    
      return () => {
        window.removeEventListener("popstate", () => {}); 
      };
    }, [navigate]);

    // Force clear all form fields on component mount to prevent autofill issues
    useEffect(() => {
      setFullName("");
      setEmail("");
      setPassword("");
      setId("");
      setRole("Doctor");
    }, []);
    
    
    // Function to log account creation events //deepa audit logs
    const logAccountCreation = async (createdFor, createdForRole, action) => {
      try {
        const db = getDatabase();
        const logRef = ref(db, "audit_logs/UserManagement/Account_Creation");
        
        // Create details object with browser and device info
        const details = {
          action: action,
          browser: getBrowserInfo(),
          device: getDeviceType()
        };
        
        // Get user location using IP geolocation API //deepa audit logs
        try {
          const response = await fetch('https://ipapi.co/json/');
          const locationData = await response.json();
          
          // Add location data to details //deepa audit logs
          details.location = `${locationData.city || 'Unknown'}, ${locationData.country_name || 'Unknown'}`;
          details.ip = locationData.ip || 'Unknown';
        } catch (locationError) {
          console.error("Error fetching location data:", locationError);
          details.location = "Unknown";
          details.ip = "Unknown";
        }
        
        // Create the audit log entry
        push(logRef, {
          event_type: "account_created",
          created_by: adminName1,
          created_for: createdFor,
          created_for_role: createdForRole,
          timestamp: new Date().toISOString(),
          details: details
        });
      } catch (error) {
        console.error("Error logging account creation:", error);
      }
    };
    
    // Helper function to get browser information //deepa audit logs
    const getBrowserInfo = () => {
      if (typeof window !== 'undefined' && window.navigator) {
        const userAgent = navigator.userAgent;
        let browserName = "Unknown";
        let browserVersion = "";
        
        if (userAgent.indexOf("Chrome") > -1) {
          browserName = "Chrome";
          const match = userAgent.match(/Chrome\/([0-9.]+)/);
          browserVersion = match ? match[1] : "";
        } else if (userAgent.indexOf("Firefox") > -1) {
          browserName = "Firefox";
          const match = userAgent.match(/Firefox\/([0-9.]+)/);
          browserVersion = match ? match[1] : "";
        } else if (userAgent.indexOf("Safari") > -1) {
          browserName = "Safari";
          const match = userAgent.match(/Version\/([0-9.]+)/);
          browserVersion = match ? match[1] : "";
        } else if (userAgent.indexOf("Edge") > -1 || userAgent.indexOf("Edg") > -1) {
          browserName = "Edge";
          const match = userAgent.match(/Edge?\/([0-9.]+)/);
          browserVersion = match ? match[1] : "";
        }
        
        return `${browserName} ${browserVersion}`;
      }
      return "Unknown";
    };

    // Helper function to get device type //deepa audit logs
    const getDeviceType = () => {
      if (typeof window !== 'undefined' && window.navigator) {
        const userAgent = navigator.userAgent;
        
        if (/Mobi|Android|iPhone|iPad|iPod/i.test(userAgent)) {
          return "Mobile";
        } else if (/Tablet|iPad/i.test(userAgent)) {
          return "Tablet";
        } else {
          return "Desktop";
        }
      }
      return "Unknown";
    };

    // Function to handle signature file upload
    const handleSignatureUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        // Check if it's an image file
        if (file.type.startsWith('image/')) {
          setSignatureFile(file);
          setSignatureFileName(file.name);
        } else {
          toast.error("Please select an image file for signature", {
            position: "top-center",
          });
          event.target.value = ""; // Clear the input
        }
      }
    };

    // Function to upload signature image to Firebase Storage
    const uploadSignatureImage = async (file, doctorFullName, doctorId) => {
      try {
        const fileName = `${file.name}`;
        const imagePath = `superadmin/admins/${adminName1}/DoctorSignature/${doctorFullName}+${doctorId}/${fileName}`;
        const imageRef = storageRef(storage, imagePath);
        
        // Upload the file
        const snapshot = await uploadBytes(imageRef, file);
        
        // Get the download URL
        const downloadURL = await getDownloadURL(snapshot.ref);
        
        console.log("Signature uploaded successfully:", downloadURL);
        return downloadURL;
      } catch (error) {
        console.error("Error uploading signature:", error);
        throw error;
      }
    };

    // Function to clear all form fields
    const clearFormFields = () => {
      setFullName("");
      setRole("Doctor");
      setEmail("");
      setPassword("");
      setId("");
      setSignatureFile(null);
      setSignatureFileName("");
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      async function onRegister() {
        try {
          const userCredential = await createUserWithEmailAndPassword(auth, Email, password);
          
          // Create the doctor account in the database
          const doctorId = role + "-" + fullName; //deepa audit logs - storing ID for audit log
          const doctorData = {
            Name: fullName,
            Email: Email,
            Password: password,
            Role: role,
            ID: "D" + id,
            privacyAccepted: false,
          };

          // If HOD role and signature file exists, upload the signature
          if (role === "HOD" && signatureFile) {
            try {
              const signatureURL = await uploadSignatureImage(signatureFile, fullName, "D" + id);
              doctorData.SignatureURL = signatureURL;
              console.log("Signature uploaded and URL saved:", signatureURL);
            } catch (error) {
              console.error("Error uploading signature:", error);
              toast.error("Failed to upload signature image", {
                position: "top-center",
              });
              return; // Stop the registration process if signature upload fails
            }
          }

          // Save doctor data to database
          await set(
            ref(
              db,
              `superadmin/admins/${adminName1}/doctors/` + doctorId
            ),
            doctorData
          );
          
          // Log the account creation event //deepa audit logs
          const actionDescription = role === "Doctor" ? 
            "Doctor account created by Admin" : 
            role === "Radiologist" ? "Radiologist account created successfully" :
            "HOD account created successfully";
            
          logAccountCreation(doctorId, role.toLowerCase(), actionDescription);
          
          // Check the role and show corresponding success message
          if (role === "Doctor") {
            notifySuccess("Doctor Added Successfully");
          } else if (role === "Radiologist") {
            notifySuccess("Radiologist Added Successfully");
          } else if (role === "HOD") {
            notifySuccess("HOD Added Successfully");
          }

          // Clear all form fields
          e.target.reset();
          clearFormFields();
          
          setTimeout(function () {
            navigate("/Admin", { replace: true }); // Ensures back button goes to Admin.jsx
          }, 2000);
          
        } catch (error) {
          // Log the failure attempt
          const doctorId = role + "-" + fullName;
          logAccountCreation(
            doctorId,
            role.toLowerCase(),
            `Doctor creation failed: ${error.code}`
          );
          notifyWarning(error);
        }
      }

      onRegister();
    };

    const handleLogout = async () => {
      try {
        await logOut();
        // navigate("/");
        navigate("/Admin", { replace: true }); // Always navigate back to Admin.jsx after logout

      } catch (error) {
        console.log(error.message);
      }
    };

    return (
      <>
        <div>
          <h2 className="text-center h2addpdoctoradmin ">
            Specialist Enrollment
          </h2>

          <form className="adminaddDoctorForm " onSubmit={handleSubmit}>
            <strong className="adminstrongaddpatient">FULL NAME</strong>
            <input
              className="inputaddadmin"
              type="text"
              placeholder="Enter Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              autoComplete="off"
              required
            ></input>
            <strong className="adminstrongaddpatient">ID</strong>
            <input
              className="inputaddadmin"
              placeholder="Enter ID"
              value={id}
              onChange={(e) => setId(e.target.value)}
              autoComplete="off"
              required
              type="text"
            ></input>
            <strong className="adminstrongaddpatient">ROLE</strong>
            <select
              className="inputaddadmin"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="Doctor">Doctor</option>
              <option value="Radiologist">Radiologist</option>
              <option value="HOD">HOD</option>
            </select>
            
            {/* Upload Signature field - only visible for HOD role */}
            {role === "HOD" && (
              <>
                <strong className="adminstrongaddpatient">UPLOAD SIGNATURE</strong>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleSignatureUpload}
                    style={{ display: "none" }}
                    id="signature-upload"
                  />
                  <label
                    htmlFor="signature-upload"
                    className="inputaddadmin"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #ced4da",
                      padding: "8px 12px",
                      borderRadius: "4px",
                      display: "inline-block",
                      textAlign: "center",
                      minHeight: "38px",
                      lineHeight: "22px"
                    }}
                  >
                    {signatureFileName || "Choose Signature Image"}
                  </label>
                  {signatureFileName && (
                    <span style={{ color: "#28a745", fontSize: "14px" }}>
                      ✓ Selected
                    </span>
                  )}
                </div>
              </>
            )}
            
            <strong className="adminstrongaddpatient">EMAIL</strong>
            <input
              className="inputaddadmin"
              placeholder="Enter Your Email"
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="off"
              required
              type="email"
            ></input>
            <strong className="adminstrongaddpatient">PASSWORD</strong>
            <input
              className="inputaddadmin"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
              type="password"
            ></input>
            <button className="adddoctorbtnadmin">Add</button>
            <ToastContainer />
          </form>
        </div>
        {/* <div>
          <ChatNot />
        </div> */}
      </>
    );
  };

  export default AddDoctor;
